module.exports = __webpack_public_path__ + "img/162005.844dca8a.jpg";